import React, {Component} from 'react';
import {Container as FluxContainer} from 'flux/utils'
import ApplicationStore from '../data/store/ApplicationStore';
import {ServerActions} from '../data/Action';
import moment from 'moment';

import params from '../config/params';
import config from '../config/config';
import sdk from '../script';
import Map from './Map';
import Sidebar from './Sidebar';
import Statistics from './Statistics';
import commons from '../script/utils/commons';
import '../style/ui.css';
import './AppContainer.css';
import DialogConfirmation from "./Dialog/confirmation";

import {Client} from '@stomp/stompjs';


// const MILIS_5_MINUTES = 300000;
const MILIS_3_MINUTES = 180000;
const MILIS_1_MINUTE = 60000;


const driverVisibilityFilterToggle = {
    free: true,
    returning: true,
    busy: true,
};


var lastServerDataTimestamp = -1;

export class AppContainer extends Component {


    constructor(props) {
        super(props);

        this.state = {
            isSignedIn: false,
            storeName: 'PH DeliveryTracker',
            data: {
                store: {
                    lat: 0,
                    lng: 0,
                    avgDeliveryTime: 0,
                    avgDrivingTime: 0,
                    avgPreparationTime: 0,
                    avgRating: 0,
                    expectedDeliveryTime: null,
                    drivers: [],
                    orders: [],
                    alarms: [],
                    scheduled: {}
                },
            },
            highlightedDriver: null,
            selectedDriver: null,
            // TODO handle store's polygon delivery area
            zoom: 14,
            center: {lat: 41.166020, lng: -8.626776},
            map: {orderSelected: null},
            googleMaps: {},
            login: {
                user: commons.getLoginUser(),
                storeId: commons.getLoginStoreId(),
            }
        }

        const loginStoreCode = this.state.login.storeId;
        const options = {
            brokerURL: config.brokerURL + '?store=' + loginStoreCode,
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000,
            connectHeaders: {
                login: "admin",
                passcode: "admin",
            },
            debug: function (str) {
                // console.debug(">>> DEBUG:" + str);
            },

            onWebSocketError: function (event) {
                if (this.local === undefined) {
                    this.local = {}
                }
                if (this.local.failures === undefined) {
                    this.local.failures = 0;
                }

                this.local.failures++;
                console.debug("Failures: " + this.local.failures);
                if (this.local.failures > 5) {
                    this.deactivate();
                }
            },
        };

        this.stompClient = new Client(options);


    }


    disconnectStompClient(ctx) {
        let client = ctx.stompClient;

        if (client.local === undefined) {
            client.local = {
                subscribedTopics: [],
                failures: 0
            };
        }

        let subscribedTopics = client.local.subscribedTopics;
        if (subscribedTopics !== undefined && subscribedTopics.length > 0) {
            subscribedTopics.forEach(topic => {
                try {
                    client.unsubscribe(topic);
                } catch (err) {
                    console.error("Failure to unsubscribe Topic (" + topic + "): " + err.message);
                }
            });
        }

        client.local.subscribedTopics = [];
        client.local.failures = -1;
        client.deactivate();
    }

    connectStompClient(ctx, loginStoreCode) {
        let client = ctx.stompClient;

        // Check if is attemping to connect
        if (client.active && !client.connected) {
            return;
        }

        if (client.local === undefined) {
            client.local = {
                subscribedTopics: [],
                failures: 0
            };
        }

        let subscribedTopics = client.local.subscribedTopics;
        if (subscribedTopics !== undefined && subscribedTopics.length > 0) {
            subscribedTopics.forEach(topic => {
                try {
                    client.unsubscribe(topic);
                } catch (err) {
                    console.error("Failure to unsubscribe Topic (" + topic + "): " + err.message);
                }
            });
        }

        client.local.subscribedTopics = [];


        client.onConnect = (frame) => {

            client.local.failures = 0;
            // Do something, all subscribes must be done is this callback
            // This is needed because this will be executed after a (re)connect
            const storeCode = loginStoreCode;
            const storeTopic = '/topic/stores/' + storeCode + "/info";
            const driversTopic = '/topic/stores/' + storeCode + "/drivers";
            client.subscribe(storeTopic, (message) => {
                // console.error(message.body);
                const store = JSON.parse(message.body);
                console.log(Object.keys(message))


                let currentStoreCode = this.state.login.storeId;

                if (currentStoreCode === undefined || currentStoreCode !== storeCode) {
                    client.unsubscribe(storeTopic);
                    return;
                }

                const messageTimeStamp = message.headers.timestamp;
                if (messageTimeStamp > lastServerDataTimestamp) {
                    lastServerDataTimestamp = messageTimeStamp;
                    console.warn(store);
                    this.updateServerData(store);
                } else {
                    let diff = messageTimeStamp - lastServerDataTimestamp;
                    console.debug("No update, older message {last: " + lastServerDataTimestamp + ", current: " + messageTimeStamp + ", diff: " + diff + "}")
                }
            });

            console.debug("Registered: " + storeTopic);
            client.local.subscribedTopics.push(storeTopic);


            client.subscribe(driversTopic, (message) => {
                console.error(message.body);
                const drivers = JSON.parse(message.body);


                let currentStoreCode = this.state.login.storeId;

                if (currentStoreCode === undefined || currentStoreCode !== storeCode) {
                    client.unsubscribe(storeTopic);
                    return;
                }

                if (!Array.isArray(drivers)){
                    console.error("message from topic ("+driversTopic+") is not an array!")
                    console.debug(message.body)
                    return;
                }


                const messageTimeStamp = message.headers.timestamp;

                if (messageTimeStamp > lastServerDataTimestamp) {
                    lastServerDataTimestamp = messageTimeStamp;
                    console.warn(drivers);
                    this.updateDriversLocation(drivers);
                } else {
                    let diff = messageTimeStamp - lastServerDataTimestamp;
                    console.debug("No update, older message {last: " + lastServerDataTimestamp + ", current: " + messageTimeStamp + ", diff: " + diff + "}")
                }
            });

            console.debug("Registered: " + driversTopic);
            client.local.subscribedTopics.push(driversTopic);

        };

        client.onStompError = function (frame) {
            // Will be invoked in case of error encountered at Broker
            // Bad login/passcode typically will cause an error
            // Complaint brokers will set `message` header with a brief message. Body may contain details.
            // Compliant brokers will terminate the connection after any error
            console.log('Broker reported error: ' + frame.headers['message']);
            console.log('Additional details: ' + frame.body);
        };


        client.activate();
    }


    componentWillUnmount() {
        this.disconnectStompClient(this);
    }


    componentDidMount() {
        const statisticsStartDate = window.localStorage.getItem('statisticsStartDate');

        if (this.stompClient === undefined) {
            console.log("Stomp Client not initialized");
        }

        // TODO improve differentiation between different error cases
        return sdk.store.getStoreInfo(this.state.login.storeId, {
            statisticsFrom: statisticsStartDate && moment().diff(moment(statisticsStartDate), 'hours') <= 3 ? statisticsStartDate : null,
        })
            .then(store => {
                this.setState({
                    storeName: store.name,
                    data: {store},
                    isSignedIn: true,
                    center: {lat: store.lat, lng: store.lng},
                });

                this.startPolling();

            }).catch(err => {
                console.error(err);
                this.setState({isSignedIn: false});

                // BrowserRouter.push('/unauthorised');
                this.redirectRoute('/unauthorised');
            });
    }


    getStatusFilter(status) {
        return driverVisibilityFilterToggle[status];
    }

    getDriver(id) {
        return this.state.data.store.drivers.find(driver => driver.id == id); // eslint-disable-line
    }

    resetStatistics() {
        window.localStorage.setItem('statisticsStartDate', moment().format('YYYY-MM-DD[T]HH:mm:ss[.]SSSZZ'));
        this.setState({
            data: {
                store: {
                    lat: this.state.data.store.lat,
                    lng: this.state.data.store.lng,
                    avgDeliveryTime: 0,
                    avgDrivingTime: 0,
                    avgPreparationTime: 0,
                    avgRating: 0,
                    drivers: this.state.data.store.drivers,
                    orders: this.state.data.store.orders,
                    alarms: this.state.data.store.alarms,
                }
            },
        });
    }

    startPolling() {
        setTimeout(this.polling.bind(this, this.state.login), params.pollingInterval);
    }

    polling(login) {

        const statisticsStartDate = window.localStorage.getItem('statisticsStartDate');


        // Validate Session
        if (login === undefined || login.storeId === undefined || login.storeId === null) {
            console.debug("Pooling.....(/unauthorised)");
            this.setState({isSignedIn: false});
            // BrowserRouter.push('/unauthorised');
            this.redirectRoute('/unauthorised');
            return;
        }

        if (this.stompClient === undefined || this.stompClient === null || !this.stompClient.connected) {
            this.connectStompClient(this, this.state.login.storeId);
        }


        if (this.stompClient !== undefined && this.stompClient != null && this.stompClient.connected) {
            console.debug("Pooling.....(using stomp)");
            setTimeout(this.polling.bind(this, this.state.login), params.pollingInterval);
            return;
        }


        console.debug("Pooling.....(active polling)");
        // Retrieve Information
        var result = sdk.store.getStoreInfo(this.state.login.storeId, {
            statisticsFrom: statisticsStartDate && moment().diff(moment(statisticsStartDate), 'hours') <= 3 ? statisticsStartDate : null,

        }).then(store => {

            this.updateServerData(store);

            // Operation success, retry polling
            setTimeout(this.polling.bind(this, this.state.login), params.pollingInterval);
        }).catch(err => {
            console.error(err);

            // browserHistory.push('/unauthorised');
            setTimeout(this.polling.bind(this, this.state.login), params.pollingInterval * 2);
        });


        return result;
    }



    updateServerData(store){
        // console.log("Update State and got to next Polling")


        if (store && store.orders && store.orders.length > 1){
            store.orders.sort((a, b) => {
                const aDeliveryTime = (a.requestDate ? a.requestDate : a.deliveryDate ? moment(a.deliveryDate).unix()*1000 : 0);
                const bDeliveryTime = (b.requestDate ? b.requestDate : b.deliveryDate ? moment(b.deliveryDate).unix()*1000 : 0);
                return aDeliveryTime - bDeliveryTime;
            });
        }

        if (store && store.scheduled && store.scheduled.length > 1){
            store.scheduled.sort((a, b) => {
                const aDeliveryTime = (a.requestDate ? a.requestDate : a.deliveryDate ? moment(a.deliveryDate).unix()*1000 : 0);
                const bDeliveryTime = (b.requestDate ? b.requestDate : b.deliveryDate ? moment(b.deliveryDate).unix()*1000 : 0);
                return aDeliveryTime - bDeliveryTime;
            });
        }


        this.addReturningDriversInfo(store);
        this.setState({data: {store}});
        ServerActions.updateServerData(store);
    }

    updateDriversLocation(drivers){
        const updatedDrivers = commons.mergeArraysDistinct(drivers, this.state.data.store.drivers);

        let store = Object.assign({}, this.state.data.store);
        store.drivers = updatedDrivers;

        this.addReturningDriversInfo(store);
        this.setState({data: {store}});
    }



    addReturningDriversInfo(store) {

        if (config.mock && config.mock === true) {
            return store;
        }

        const gmaps = this.state.googleMaps;

        // Map might not have loaded yet
        if (!gmaps.map) {
            return Promise.resolve(store);
        }


        const filteredDrivers = store.drivers.filter(driver => driver.status === 'returning');


        let curTime = Date.now();

        const currentReturningDrivers = (this.state.data.store && this.state.data.store.drivers ? this.state.data.store.drivers.filter(driver => driver.status === 'returning') : []);

        console.debug("Current Returning Drivers: " + currentReturningDrivers.length);
        let driversToUpdate = [];

        /*
         * Attempting to reduce the number of call to google api
         */
        let cacheUpdated = 0;
        filteredDrivers.forEach(driver => {
            let updated = false;
            currentReturningDrivers.forEach(curDriver => {
                if (driver.id === curDriver.id) {
                    if (curDriver._returningInfo && curDriver._returningInfo.timestamp) {
                        let sinceLastUpdate = curTime - curDriver._returningInfo.timestamp;

                        if (sinceLastUpdate < MILIS_3_MINUTES) {
                            let estimatedEta = curDriver._returningInfo.duration - sinceLastUpdate;

                            console.debug("sinceLastUpdate: " + sinceLastUpdate + ", duration: " + curDriver._returningInfo.duration + ", ETA: " + estimatedEta);

                            // near the store update more often
                            if (estimatedEta > MILIS_1_MINUTE || (estimatedEta < MILIS_1_MINUTE && sinceLastUpdate < MILIS_1_MINUTE)) {
                                driver._returningInfo = {
                                    duration: curDriver._returningInfo.duration,
                                    distance: curDriver._returningInfo.distance,
                                    timestamp: curDriver._returningInfo.timestamp
                                };
                                updated = true;
                                cacheUpdated++;
                            }
                        }
                    }
                }
            });
            if (!updated) {
                driversToUpdate.push(driver);
            }
        });

        const returningDrivers = driversToUpdate;
        console.debug("Updating Returning drivers  [" + returningDrivers.length + ", " + cacheUpdated + "]");

        return Promise.all(returningDrivers.map(driver => new Promise((resolve, reject) => {
            gmaps.distanceService.getDistanceMatrix({
                origins: [{lat: driver.coordinates.lat, lng: driver.coordinates.lng}],
                destinations: [{lat: store.lat, lng: store.lng}],
                travelMode: gmaps.gmaps.TravelMode.DRIVING,
            }, (response, status) => {
                if (status !== 'OK' ||
                    !response.rows.length ||
                    !response.rows[0].elements.length ||
                    response.rows[0].elements[0].status !== 'OK') {
                    console.error('Distance matrix request failed:', status, response.error_message);
                    return reject(new Error('Distance matrix request failed: ' + status + ' ' + response.error_message));
                }

                resolve({
                    duration: response.rows[0].elements[0].duration.value * 1e3, // miliseconds
                    distance: response.rows[0].elements[0].distance.value, // meters
                });
            });
        })))
            .then(driversReturningInfo => {
                driversReturningInfo.forEach((info, index) => {
                    returningDrivers[index]._returningInfo = {
                        duration: info.duration,
                        distance: info.distance,
                        timestamp: curTime
                    };
                });

                return store;
            })
            // Fail safe, because this is just extra information
            .catch(err => {
                console.error(err);
                return store;
            });
    }


    render() {
        return (
            <div id="app">
                <div className="background-blur"/>
                {this.state.isSignedIn && (
                    <div className={"map-wrapper no-animation"}>
                        <Map
                            // Global Application State
                            appState={this.state.application}
                            // Information of the store
                            store={this.state.data.store}
                            // List of drivers
                            drivers={this.state.data.store.drivers.filter(driver => this.getStatusFilter(driver.status))}
                            // Driver to fit in bounds
                            fitDriver={this.state.fitDriver}
                            center={this.state.center}
                            zoom={this.state.zoom}
                        />
                        <Sidebar
                            appState={this.state.application}
                            storeName={this.state.storeName}

                            // Data
                            orders={this.state.data.store.orders}
                            drivers={this.state.data.store.drivers}
                            scheduled={this.state.data.store.scheduled}

                            getStatusFilter={this.getStatusFilter.bind(this)}
                            onChangeFilter={this.onChangeFilter.bind(this)}
                        />
                        <Statistics
                            scheduled={this.state.data.store.scheduled}
                            avgPreparationTime={this.state.data.store.avgPreparationTime}
                            avgDispatchTime={this.state.data.store.avgDispatchTime}
                            avgStoreTime={this.state.data.store.avgStoreTime}
                            avgDrivingTime={this.state.data.store.avgDrivingTime}
                            avgDeliveryTime={this.state.data.store.avgDeliveryTime}
                            avgRating={this.state.data.store.avgRating}
                            expectedDeliveryTime={this.state.data.store.expectedDeliveryTime}
                            onReset={this.resetStatistics.bind(this)}
                        />
                    </div>)
                }
                {!this.state.isSignedIn && (
                    <div className="page-wrap">
                        <div className="container">
                            <div className="message animated bounceIn">
                                <div className="display-table">
                                    <div className="display-table-cell">
                                        <h2>loading...</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}


                {this.state.isSignedIn && this.state.data.store.alarms && this.state.data.store.alarms[0] && (
                    <div className="page-wrap">
                        <div className="container">
                            <div className="message animated bounceIn">
                                <div className="display-table">
                                    <div className="display-table-cell modal-warning">
                                        <div className="modal-warning-header">
                                            <h2>Entregador em perigo</h2>
                                        </div>
                                        <div className="modal-warning-body">
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <td>Alarme:</td>
                                                    <td>{this.state.data.store.alarms[0].id}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nome:</td>
                                                    <td>{this.state.data.store.alarms[0].driverName}</td>
                                                </tr>
                                                <tr>
                                                    <td>Localização:</td>
                                                    <td>{this.state.data.store.alarms[0].location.lat + ", " + this.state.data.store.alarms[0].location.lng}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="modal-warning-footer">
                                            <button id="btn_alarm_close" onClick={() => {
                                                this.closePanicDialog(this.state.data.store.alarms[0])
                                            }}>Fechar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}
                <DialogConfirmation
                    isSignedIn={this.state.isSignedIn}
                    appState={this.state.application}
                />
            </div>
        );
    }


    closePanicDialog(alarm) {
        if (alarm === undefined || alarm === null) {
            return;
        }

        sdk.store.closeDriverAlarm(alarm);
        // console.log("Alarm: " + JSON.stringify(alarm));
        // console.log("Message from click: " + this.state.data.store.alarms.length);
        let newState = Object.assign({}, this.state);
        newState.data.store.alarms.shift();
        this.setState(newState)
    }


    redirectRoute(location) {
        if (this.props.history) {
            this.props.history.push(location)
        } else {
            console.error("No history available to redirect to route location: " + location);
        }
    }


    /*
     * Event Handlers
     */
    onChangeFilter(filterValue) {
        driverVisibilityFilterToggle[filterValue] = !driverVisibilityFilterToggle[filterValue];
    }


    onDriverClick(driverId) {
        this.setState({fitDriver: this.getDriver(driverId)});
        setTimeout(() => this.setState({fitDriver: null}), 1000);
    }

    onOrderClick(order) {
        this.setState({
            map: {
                orderSelected: this.state.map.orderSelected &&
                this.state.map.orderSelected.id === order.id ? null : order,
            },
        });
    }


    /*
     * FLUX Functions...
     */
    static getStores() {
        return [
            ApplicationStore,
        ];
    }

    static calculateState() {

        let state = ApplicationStore.getState().toJS();
        // console.log("State: " + JSON.stringify(state));
        return state;
    }


}


export default FluxContainer.create(AppContainer);


// WEBPACK FOOTER //
// ./src/app/AppContainer.js